export const PERMISSION_DENIED_MESSAGE = 'Insufficient permission';

// 403 jo permission ki wajah se aaya ho (backend: { success:false, error:"...sufficient permission...", required })
export const isPermissionDenied = (status, data) =>
  status === 403 && !!data && (data.required !== undefined || /sufficient permission/i.test(data.error || data.message || ''));

// Daily Closing errors (409/403/400 with these codes): make sure `message` mirrors `error`, so every
// screen (some read data.error, some data.message) shows the same English text.
const DAY_CLOSING_CODES = ['DAY_CLOSE_REQUIRED', 'DAY_CLOSED', 'SOURCE_LINKED_ENTRY', 'EDIT_REASON_REQUIRED', 'CLOSE_NOT_ALLOWED', 'ALREADY_CLOSED'];
export const normalizeDayClosingError = (data) => {
  if (data && DAY_CLOSING_CODES.includes(data.code) && data.error && !data.message) {
    data.message = data.error;
    return true;
  }
  return false;
};

// Response body me message ko ek hi text me badal deta hai, taake har page wahi message dikhaye.
export const normalizePermissionError = (status, data) => {
  if (isPermissionDenied(status, data)) {
    data.error = PERMISSION_DENIED_MESSAGE;
    data.message = PERMISSION_DENIED_MESSAGE;
    return true;
  }
  return false;
};

/**
 * Utility to handle API errors and map them to Ant Design form fields.
 * Specifically handles MySQL "Duplicate entry" errors.
 * 
 * @param {Error} error - The error object from axios/api call
 * @param {Object} form - Ant Design form instance
 * @returns {boolean} - Returns true if the error was handled and mapped to a field, false otherwise
 */
export const handleApiError = (error, form) => {
  if (error?.response) {
    normalizePermissionError(error.response.status, error.response.data);
    normalizeDayClosingError(error.response.data);
  }
  if (!form || !error) return false;

  const errorData = error.response?.data;
  // Try to get error message from 'error' or 'message' property
  const errorMsg = errorData?.error || errorData?.message;

  if (!errorMsg) return false;

  // Handle MySQL Duplicate Entry Error
  // Example: "Duplicate entry 'PRD-004' for key 'sku'"
  if (errorMsg.includes('Duplicate entry') && errorMsg.includes('for key')) {
    const match = errorMsg.match(/key '(.+)'/);
    if (match) {
      const fieldKey = match[1];
      
      // Clean up the key if it has prefixes (e.g., 'table_name.field_name')
      const fieldName = fieldKey.split('.').pop();

      // Check if this field exists in the form
      // Note: Ant Design form.getFieldsValue() gives the current values and keys
      const formFields = Object.keys(form.getFieldsValue());
      
      if (formFields.includes(fieldName)) {
        form.setFields([
          {
            name: fieldName,
            errors: [errorMsg]
          }
        ]);
        return true;
      }
    }
  }

  // Handle standard validation errors object if present
  if (errorData?.errors && typeof errorData.errors === 'object') {
    const fields = Object.entries(errorData.errors).map(([name, messages]) => ({
      name,
      errors: Array.isArray(messages) ? messages : [messages]
    }));
    
    if (fields.length > 0) {
      form.setFields(fields);
      return true;
    }
  }

  return false;
};
